import { Component } from '@angular/core';

@Component({
  selector: 'kng-side-menu',
  templateUrl: './kng-side-menu.component.html',
  styleUrls: []
})
export class KngSideMenuComponent {

  public open: boolean;

  constructor() { }

  toggleOpen() {
    this.open = ! this.open;
  }

  isOpen() {
    return this.open === true;
  }

  closePanel() {
    this.open = false;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-side-menu/kng-side-menu.component.ts